// extracted by mini-css-extract-plugin
export default {"pricesSummary":"PricesSummary_pricesSummary__vwj1w","pricesSummaryTitle":"PricesSummary_pricesSummaryTitle__4iIqb","pricesSummaryPrice":"PricesSummary_pricesSummaryPrice__49luA"};